import {SearchModel} from '@features/search/interfaces';

export function getDefaultSearchModel(): SearchModel {
    return {analogs: [], searched: [], original: []};
}